'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './survey-result.routes';

export class SurveyResultComponent {
  constructor(Auth, SurveysService, SurveyResultsService, dialogs, $uibModal, $stateParams, $scope, Config) {
    'ngInject';
    this.baseContainerClass = Config.getPlatformConfig().getBaseContainerClass();
    this.SurveysService = SurveysService;
    this.SurveyResultsService = SurveyResultsService;
    this.isAdmin = Auth.isAdminSync;
    this.Auth = Auth;
    this.$scope = $scope;

    this.model = {};
    this.surveyId = $stateParams.id;

    this.chartOptionsStartFromZero = {
      scales: {
        xAxes: [{
          ticks: {
            beginAtZero: true
          }
        }],
        yAxes: [{
          ticks: {
            beginAtZero: true
          }
        }]
      }
    };

    this.chartData = [];
    this.chartLabel = [];

    this.responses = [];
    this.totalResponses = {};

    this.count = 0;

    this.dialogs = dialogs;
    this.$uibModal = $uibModal;

    this.SurveysService.get({id: this.surveyId}, (survey) => {
      this.survey = survey;

      for (let i=0; i<survey.questions.length; i++) {
        let key = "question_"+i;

        this.responses[key] = [];
        this.totalResponses[key] = 0;

        switch (survey.questions[i].type) {
          case 'text':
            break;
          case 'select-one':
          case 'select-many':
            survey.questions[i].answers.forEach(answer => {
              this.responses[key].push({answer: answer, count: 0})
            });
            break;
        }

      }

      this.SurveyResultsService.getResultsBySurvey({survey: this.surveyId}, results => {

        let _results = results.filter(result => result.hasOwnProperty("answers"));

        this.count = _results.length;

        _results.forEach(result => {
          for (let i=0; i<survey.questions.length; i++) {
            let key = "question_" + i;

            switch (survey.questions[i].type) {
              case 'text':

                if (!result.answers[key] || result.answers[key].trim() === '')
                  break;

                let idx1 = this.responses[key].findIndex(elm => elm.answer == result.answers[key]);
                if (idx1 !== -1) {
                  this.responses[key][idx1].count++;
                } else {
                  this.responses[key].push({answer: result.answers[key], count: 1});
                }
                break;
              case 'select-one':
                try {
                  let idx = this.responses[key].findIndex(elm => elm.answer == result.answers[key]);
                  this.responses[key][idx].count++;
                  this.totalResponses[key]++;
                } catch(e) {
                  console.log("Warning: Answer possibility removed; Answer will not count: " + e)
                }
                break;
              case 'select-many':
                if (result.answers[key]) {
                  result.answers[key].forEach(answer => {
                    try {
                      let idx = this.responses[key].findIndex(elm => elm.answer == answer);
                      this.responses[key][idx].count++;
                      this.totalResponses[key]++;
                    } catch(e) {
                      console.log("Warning: Answer possibility removed; Answer will not count: " + e)
                    }
                  });
                }
                break;
            }
          }
        });

        for (let i=0; i<survey.questions.length; i++) {
          let key = "question_" + i;

          let answers = this.responses[key];

          this.chartData[i] = [];
          this.chartLabel[i] = [];

          answers.forEach(answer => {
            this.chartData[i].push(answer.count);
            this.chartLabel[i].push(answer.answer);
          });
        }

      });

    }, err => {
      console.log("Could not retrieve survey results from server.")
    })
  }

}

export default angular.module('conduu.surveyResult', [uiRouter])
  .config(routes)
  .component('surveyResult', {
    template: require('./survey-result.html'),
    controller: SurveyResultComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/survey/result/survey-result.component.js